import React, { Component, ReactElement } from "react";
import { Buffer } from "buffer";
import "./MainLayout.css";
import { withRouter } from "../../hoc/withRouter";
import { Avatar, Avatar as UserAvatar, Breadcrumb, Dropdown, Layout, Menu, Select, Typography } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  HomeOutlined,
  AppstoreOutlined,
  AuditOutlined,
  DeliveredProcedureOutlined,
  ShoppingOutlined,
  SettingFilled,
  TeamOutlined,
  ToolOutlined,
  FileDoneOutlined,
  FileSyncOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import ButtonLogout from "./LogoutButton";
import SubMenu from "antd/es/menu/SubMenu";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import Notification from "./Notification";
import { appVersion } from "../../config/data/appConfig";

const { Header, Sider, Content, Footer } = Layout;
const menuAuthenticated: ReactElement = (
  <Menu>
    <Menu.Item key={"logout"}>
      <ButtonLogout />
    </Menu.Item>
  </Menu>
);

class AppLayout extends Component<any, any> {
  private readonly initState!: any;

  constructor(props: any) {
    super(props);

    this.initState = {
      collapsed: false,
      viewClass: "desktop",
      user: "",
      dealer: [],
      defaultDealer: {},
      defaultDealerLink: "",
      showOptionDealer: false,
      listMenu: [],
    };
    this.state = { ...this.initState };
  }

  updateDimensions = () => {
    if (window.innerWidth < 1080) {
      this.setState({ collapsed: true, viewClass: "mobile" });
    } else {
      this.setState({ collapsed: false, viewClass: "desktop" });
    }
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onChange = (value: any, option: any) => {
    this.setState({
      defaultDealer: value,
      defaultDealerLink: value.replace(/#/g, "-"),
    });
    this.props.onChangeDealer(option);
    this.props.history.push("/" + value.replace(/#/g, "-") + "/dashboard");
  };

  async componentDidMount() {
    let user, dealer, defaultDealer, accessMenu;
    const cookies = new Cookies();
    const token = cookies.get("_t");
    if (token) {
      user = JSON.parse(Buffer.from(cookies.get("_u"), "base64").toString());
      dealer = JSON.parse(Buffer.from(cookies.get("_d"), "base64").toString());
      accessMenu = JSON.parse(Buffer.from(cookies.get("_am"), "base64").toString());
      defaultDealer = this.props.match.params.dealerCode.replace(/-/g, "#");
    }

    await this.promisedSetState({
      user: user,
      dealer: dealer,
      defaultDealer: defaultDealer,
      defaultDealerLink: defaultDealer.replace(/#/g, "-"),
      showOptionDealer: true,
      listMenu: accessMenu,
    });

    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <Layout>
        <Sider className={`sider`} trigger={null} collapsible collapsed={this.state.collapsed}>
          <div className="app-main-header">
            <Avatar src={"/assets/img/logootodis.png"} />{" "}
            <b style={this.state.collapsed ? { display: "none" } : { fontSize: "115%" }}>
              {" "}
              Otodis <i style={{ fontWeight: "normal", fontSize: "50%" }}> v-{appVersion}</i>
            </b>
          </div>

          <Menu defaultSelectedKeys={this.props.defaultSelectedKeys} defaultOpenKeys={this.props.defaultOpenKeys} mode="inline" theme="dark" inlineCollapsed={this.state.collapsed}>
            <Menu.Item key="m-dashboard" icon={<HomeOutlined />}>
              <Link to={`/${this.state.defaultDealerLink}/dashboard`}>Dashboard</Link>
            </Menu.Item>
            {(this.state.listMenu.includes(2) ||
              this.state.listMenu.includes(3) ||
              this.state.listMenu.includes(4) ||
              this.state.listMenu.includes(5) ||
              this.state.listMenu.includes(19) ||
              this.state.listMenu.includes(24) ||
              this.state.listMenu.includes(42) ||
              this.state.listMenu.includes(47) ||
              this.state.listMenu.includes(51) ||
              this.state.listMenu.includes(69)) && (
              <SubMenu key="sm-stock" icon={<AppstoreOutlined />} title="Stock">
                {(this.state.listMenu.includes(24) || this.state.listMenu.includes(3) || this.state.listMenu.includes(42)) && (
                  <SubMenu key="sm-sm-stock" title="Stock">
                    {this.state.listMenu.includes(24) && (
                      <Menu.Item key="m-engine-number-monitoring">
                        <Link to={`/${this.state.defaultDealerLink}/engine-number-monitoring`}>Monitoring Nosin</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(3) && (
                      <Menu.Item key="m-stock">
                        <Link to={`/${this.state.defaultDealerLink}/list-active-stock`}>List Active Stock</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(69) && (
                      <Menu.Item key="m-update-stock-variant">
                        <Link to={`/${this.state.defaultDealerLink}/update-variant-stock`}>Update Variant Stock</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(42) && (
                      <Menu.Item key="m-update-stock">
                        <Link to={`/${this.state.defaultDealerLink}/update-status-stock`}>Update Status Stock</Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}
                {(this.state.listMenu.includes(2) || this.state.listMenu.includes(47) || this.state.listMenu.includes(19) || this.state.listMenu.includes(51)) && (
                  <SubMenu key="sm-sm-purchase" title="Pembelian">
                    {this.state.listMenu.includes(2) && (
                      <Menu.Item key="m-purchase-stock">
                        <Link to={`/${this.state.defaultDealerLink}/purchase-stock`}>Pembelian</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(47) && (
                      <Menu.Item key="m-purchase-multiple-stock">
                        <Link to={`/${this.state.defaultDealerLink}/purchase-multiple-stock`}>Import Pembelian</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(19) && (
                      <Menu.Item key="m-import-stock-wisesa">
                        <Link to={`/${this.state.defaultDealerLink}/import-stock-wisesa`}>Import Stock Wisesa</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(51) && (
                      <Menu.Item key="m-stock-daya">
                        <Link to={`/${this.state.defaultDealerLink}/stock/insert/stock-daya`}>Stock Daya</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(60) && (
                      <Menu.Item key="m-stock-chery">
                        <Link to={`/${this.state.defaultDealerLink}/stock/insert/stock-chery`}>Stock Chery</Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}
                {(this.state.listMenu.includes(5) || this.state.listMenu.includes(4)) && (
                  <SubMenu key="sm-sm-stock-warehouse" title="Stock Gudang">
                    {this.state.listMenu.includes(5) && (
                      <Menu.Item key="m-list-stock-transfer">
                        <Link to={`/${this.state.defaultDealerLink}/list-stock-transfer`}>List Perpindahan Gudang</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(4) && (
                      <Menu.Item key="m-warehouse-stock-transfer">
                        <Link to={`/${this.state.defaultDealerLink}/warehouse-stock-transfer`}>Pindah Stock Gudang</Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}

                {(this.state.listMenu.includes(26) || this.state.listMenu.includes(57)) && (
                  <SubMenu key="sm-sm-stock-json" title="JSON Stock">
                    {this.state.listMenu.includes(26) && (
                      <Menu.Item key="m-publish-stock">
                        <Link to={`/${this.state.defaultDealerLink}/publish-stock`}>Publish Stock</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(57) && (
                      <Menu.Item key="m-update-json-stock">
                        <Link to={`/${this.state.defaultDealerLink}/update-json-stock`}>Update Json Stock</Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(68) ||
              this.state.listMenu.includes(66) ||
              this.state.listMenu.includes(13) ||
              this.state.listMenu.includes(14) ||
              this.state.listMenu.includes(8) ||
              this.state.listMenu.includes(30) ||
              this.state.listMenu.includes(31) ||
              this.state.listMenu.includes(35) ||
              this.state.listMenu.includes(45) ||
              this.state.listMenu.includes(41) ||
              this.state.listMenu.includes(61) ||
              this.state.listMenu.includes(59) ||
              this.state.listMenu.includes(49)) && (
              <SubMenu key="sm-offer" icon={<ShoppingOutlined />} title="Offer">
                {(this.state.listMenu.includes(66) ||
                  this.state.listMenu.includes(30) ||
                  this.state.listMenu.includes(35) ||
                  this.state.listMenu.includes(45) ||
                  this.state.listMenu.includes(41) ||
                  this.state.listMenu.includes(61)) && (
                  <SubMenu key="sm-sm-sys-offer" title={<span dangerouslySetInnerHTML={{ __html: "Offer <i style='font-size: 70%'>SysAdmin Zone</i>" }} />}>
                    {this.state.listMenu.includes(30) && (
                      <Menu.Item key="m-book-unit">
                        <Link to={`/${this.state.defaultDealerLink}/book-unit`}>Book Unit</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(66) && (
                      <Menu.Item key="m-cancel-loan-offer">
                        <Link to={`/${this.state.defaultDealerLink}/cancel-offer-loan`}>
                          Cancel Offer <i style={{ fontSize: "70%" }}>(Loan)</i>
                        </Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(68) && (
                      <Menu.Item key="m-cancel-loan-order">
                        <Link to={`/${this.state.defaultDealerLink}/cancel-order-loan`}>
                          Cancel Order <i style={{ fontSize: "70%" }}>(Loan)</i>
                        </Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(35) && (
                      <Menu.Item key="m-cancel-offer">
                        <Link to={`/${this.state.defaultDealerLink}/cancel-offer`}>
                          Cancel Offer <i style={{ fontSize: "70%" }}>(Vehicle)</i>
                        </Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(45) && (
                      <Menu.Item key="m-remove-qc-offer">
                        <Link to={`/${this.state.defaultDealerLink}/removeQc-offer`}>Hapus QC Offer</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(41) && (
                      <Menu.Item key="m-reactive-offer">
                        <Link to={`/${this.state.defaultDealerLink}/reactive-offer`}>Reaktivasi Offer</Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(61) && (
                      <Menu.Item key="m-update-offer">
                        <Link to={`/${this.state.defaultDealerLink}/update-offer`}>
                          Update Offer <i style={{ fontSize: "70%" }}>(advance)</i>
                        </Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}
                {this.state.listMenu.includes(49) && (
                  <Menu.Item key="m-list-prebooking">
                    <Link to={`/${this.state.defaultDealerLink}/list-prebooking`}>PreBooking</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(8) && (
                  <Menu.Item key="m-list-general-offer">
                    <Link to={`/${this.state.defaultDealerLink}/list-general-offer`}>
                      Offer <i style={{ fontSize: "70%" }}>(Loan)</i>
                    </Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(13) && (
                  <Menu.Item key="m-list-offer">
                    <Link to={`/${this.state.defaultDealerLink}/list-offer`}>
                      Offer <i style={{ fontSize: "70%" }}>(Vehicle)</i>
                    </Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(14) && (
                  <Menu.Item key="m-force-autoclosing">
                    <Link to={`/${this.state.defaultDealerLink}/force-autoclosing`}>Force AutoClosing</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(31) && (
                  <Menu.Item key="m-log-automatic-closing">
                    <Link to={`/${this.state.defaultDealerLink}/log-automatic-closing`}>Log Automatic Closing</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(6) ||
              this.state.listMenu.includes(7) ||
              this.state.listMenu.includes(21) ||
              this.state.listMenu.includes(46) ||
              this.state.listMenu.includes(62) ||
              this.state.listMenu.includes(58)) && (
              <SubMenu key="sm-order" icon={<AuditOutlined />} title="Order">
                {this.state.listMenu.includes(6) && (
                  <Menu.Item key="m-order">
                    <Link to={`/${this.state.defaultDealerLink}/list-closed-order`}>List Order</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(7) && (
                  <Menu.Item key="m-create-order">
                    <Link to={`/${this.state.defaultDealerLink}/create-order`}>Buat Order</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(58) && (
                  <Menu.Item key="m-create-multi-order">
                    <Link to={`/${this.state.defaultDealerLink}/create-multi-order`}>Buat Multi Order</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(21) && (
                  <Menu.Item key="m-send-final-sale">
                    <Link to={`/${this.state.defaultDealerLink}/send-final-sale`}>Send Final Sale</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(46) && (
                  <Menu.Item key="m-monitoring-order">
                    <Link to={`/${this.state.defaultDealerLink}/monitoring-order`}>Monitoring Order</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {this.state.listMenu.includes(65) && (
              <SubMenu key="sm-loan" icon={<AuditOutlined />} title="Loan">
                {this.state.listMenu.includes(10) && (
                  <Menu.Item key="m-loan-bpkb">
                    <Link to={`/${this.state.defaultDealerLink}/loan/bpkb`}>List Loan BPKB</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(9) || this.state.listMenu.includes(10) || this.state.listMenu.includes(52) || this.state.listMenu.includes(53)) && (
              <SubMenu key="sm-delivery" icon={<DeliveredProcedureOutlined />} title="Delivery">
                {this.state.listMenu.includes(10) && (
                  <Menu.Item key="m-list-delivery">
                    <Link to={`/${this.state.defaultDealerLink}/list-delivery-order`}>List Delivery Order</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(9) && (
                  <Menu.Item key="m-create-delivery">
                    <Link to={`/${this.state.defaultDealerLink}/create-delivery-order/amren`}>Buat Delivery Amren</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(52) && (
                  <Menu.Item key="m-create-delivery-manual">
                    <Link to={`/${this.state.defaultDealerLink}/create-delivery-order/manual`}>Buat Delivery Manual</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(53) && (
                  <Menu.Item key="m-delivery-handover">
                    <Link to={`/${this.state.defaultDealerLink}/delivery-handover`}>Delivery Handover</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(12) || this.state.listMenu.includes(64)) && (
              <SubMenu key="sm-bbn" icon={<FileSearchOutlined />} title="Biro Jasa">
                {this.state.listMenu.includes(12) && (
                  <Menu.Item key="m-bbn-order">
                    <Link to={`/${this.state.defaultDealerLink}/bbn/list-order`}>Kontrol Penugasan BBN</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(64) && (
                  <Menu.Item key="m-bbn-payment-approval">
                    <Link to={`/${this.state.defaultDealerLink}/bbn/payment-approval`}>Payment Approval</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(56) ||
              this.state.listMenu.includes(11) ||
              this.state.listMenu.includes(12) ||
              this.state.listMenu.includes(15) ||
              this.state.listMenu.includes(17) ||
              this.state.listMenu.includes(63)) && (
              <SubMenu key="sm-document" icon={<AuditOutlined />} title="Dokumen">
                {/* {this.state.listMenu.includes(12) && (
                                  <Menu.Item key="m-control-bbn">
                                    <Link to={`/${this.state.defaultDealerLink}/transfer-tax-control`}>Kontrol Penugasan BBN</Link>
                                  </Menu.Item>
                                )} */}
                {this.state.listMenu.includes(56) && (
                  <Menu.Item key="m-document-handover">
                    <Link to={`/${this.state.defaultDealerLink}/document/handover`}>Dokumen Handover</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(11) && (
                  <Menu.Item key="m-new-vehicle-bbn">
                    <Link to={`/${this.state.defaultDealerLink}/new-title-transfer-tax`}>Penugasan BBN (K-Baru)</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(15) && (
                  <Menu.Item key="m-upload-doc-engine">
                    <Link to={`/${this.state.defaultDealerLink}/upload-doc-engine`}>Upload Doc Engine</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(63) && (
                  <Menu.Item key="m-upload-notice">
                    <Link to={`/${this.state.defaultDealerLink}/upload-notice`}>Manual Upload Notice </Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(20) && (
                  <Menu.Item key="m-get-ddms-bast">
                    <Link to={`/${this.state.defaultDealerLink}/get-ddms-bast`}>BAST DDMS</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(17) && (
                  <Menu.Item key="m-get-ddms-invoice">
                    <Link to={`/${this.state.defaultDealerLink}/get-ddms-invoice`}>Faktur DDMS</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(39) && (
                  <Menu.Item key="m-tax-update-ddms-invoice">
                    <Link to={`/${this.state.defaultDealerLink}/update-ddms-invoice`}>Rubah Faktur DDMS</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(22) || this.state.listMenu.includes(37) || this.state.listMenu.includes(50) || this.state.listMenu.includes(32)) && (
              <SubMenu key="sm-tax-out" icon={<FileSyncOutlined />} title="Tax OUT">
                {this.state.listMenu.includes(22) && (
                  <Menu.Item key="m-tax-out-generate-csv">
                    <Link to={`/${this.state.defaultDealerLink}/tax-out/generate-csv`}>Generate CSV</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(37) && (
                  <Menu.Item key="m-tax-out-sync-data">
                    <Link to={`/${this.state.defaultDealerLink}/tax-out/syncronisation`}>Sync Data</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(50) && (
                  <Menu.Item key="m-tax-out-transfer-tax-data">
                    <Link to={`/${this.state.defaultDealerLink}/tax-out/transfer-tax-data`}>Transfer Tax Data</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(32) && (
                  <Menu.Item key="m-tax-out-insert-tax-manual">
                    <Link to={`/${this.state.defaultDealerLink}/tax-out/manual/insert`}>Tax Manual OUT </Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(33) || this.state.listMenu.includes(36) || this.state.listMenu.includes(38)) && (
              <SubMenu key="sm-tax-in" icon={<FileDoneOutlined />} title="Tax IN">
                {this.state.listMenu.includes(36) && (
                  <Menu.Item key="m-tax-in-transfer-data">
                    <Link to={`/${this.state.defaultDealerLink}/tax-in/transfer-data`}>Transfer Tax IN</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(38) && (
                  <Menu.Item key="m-tax-in-insert-tax-manual">
                    <Link to={`/${this.state.defaultDealerLink}/tax-in/manual/insert`}>Tax Manual IN </Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(33) && (
                  <Menu.Item key="m-tax-in-insert-tax-manual-credit">
                    <Link to={`/${this.state.defaultDealerLink}/tax-in/credit/manual/insert`}>Tax Manual Credit</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {this.state.listMenu.includes(29) && (
              <SubMenu key="sm-marketing" icon={<TeamOutlined />} title="Marketing">
                {this.state.listMenu.includes(29) && (
                  <Menu.Item key="m-list-cashback-agent">
                    <Link to={`/${this.state.defaultDealerLink}/list-cashback-agent`}>List Cashback Agent</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(43) || this.state.listMenu.includes(48)) && (
              <SubMenu key="sm-bengkel" icon={<ToolOutlined />} title="Bengkel">
                {this.state.listMenu.includes(48) && (
                  <Menu.Item key="m-upload-bill-kpb">
                    <Link to={`/${this.state.defaultDealerLink}/upload-bill-kpb`}>Upload Bill KPB</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(43) && (
                  <Menu.Item key="m-purchase-order-part">
                    <Link to={`/${this.state.defaultDealerLink}/purchase-order-part`}>Purchase Order Part</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {(this.state.listMenu.includes(54) ||
              this.state.listMenu.includes(5) ||
              this.state.listMenu.includes(16) ||
              this.state.listMenu.includes(18) ||
              this.state.listMenu.includes(27) ||
              this.state.listMenu.includes(64) ||
              this.state.listMenu.includes(67) ||
              this.state.listMenu.includes(28)) && (
              <SubMenu key="sm-setting" icon={<SettingFilled />} title="Setting">
                {(this.state.listMenu.includes(54) || this.state.listMenu.includes(55)) && (
                  <SubMenu key="sm-sm-delivery" title="Delivery">
                    {this.state.listMenu.includes(54) && (
                      <Menu.Item key="m-setting-driver">
                        <Link to={`/${this.state.defaultDealerLink}/setting-driver`} style={{ fontSize: "90%" }}>
                          Driver
                        </Link>
                      </Menu.Item>
                    )}
                    {this.state.listMenu.includes(55) && (
                      <Menu.Item key="m-setting-delivery-vehicle">
                        <Link to={`/${this.state.defaultDealerLink}/setting-delivery-vehicle`} style={{ fontSize: "90%" }}>
                          Kendaraan Delivery
                        </Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}
                {this.state.listMenu.includes(64) && (
                  <Menu.Item key="m-setting-dealer">
                    <Link to={`/${this.state.defaultDealerLink}/setting-dealer`}>Dealer</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(16) && (
                  <Menu.Item key="m-setting-warehouse">
                    <Link to={`/${this.state.defaultDealerLink}/setting-warehouse`}>Gudang</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(67) && (
                  <Menu.Item key="m-setting-supplier">
                    <Link to={`/${this.state.defaultDealerLink}/setting-supplier`}>Supplier</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(27) && (
                  <Menu.Item key="m-setting-shipping">
                    <Link to={`/${this.state.defaultDealerLink}/shipping-cost`}>Biaya Tujuan</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(28) && (
                  <Menu.Item key="m-setting-order-policy">
                    <Link to={`/${this.state.defaultDealerLink}/order-policy`}>Kebijakan Order</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(18) && (
                  <Menu.Item key="m-setting-track">
                    <Link to={`/${this.state.defaultDealerLink}/setting-track`}>Track</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(18) && (
                  <Menu.Item key="m-setting-fulfillment">
                    <Link to={`/${this.state.defaultDealerLink}/setting-fulfillment`}>Fulfillment</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(40) && (
                  <Menu.Item key="m-setting-stop-closing">
                    <Link to={`/${this.state.defaultDealerLink}/setting-stop-closing`}>Stop Closing Dealer</Link>
                  </Menu.Item>
                )}
                {this.state.listMenu.includes(44) && (
                  <Menu.Item key="m-setting-service-bureau">
                    <Link to={`/${this.state.defaultDealerLink}/setting-service-bureau`}>Service Bureau</Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background">
            {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: "trigger",
              onClick: this.toggle,
            })}

            {this.state.showOptionDealer && (
              <Select defaultValue={this.state.defaultDealer} className={`dealer-opt-${this.state.viewClass}`} onChange={this.onChange}>
                {this.state.dealer.map((item: any, i: number) => (
                  <Select.Option key={item?.DealerCode} value={item?.DealerCode}>
                    {item?.DealerName}
                  </Select.Option>
                ))}
              </Select>
            )}

            <Notification />

            <Dropdown className={"header-right"} overlay={menuAuthenticated}>
              <span className="action account">
                <UserAvatar size="small" icon={<UserOutlined />} className="avatar" />
                <Typography.Text style={this.state.collapsed ? { display: "none" } : {}}> &nbsp; {this.state.user}</Typography.Text>
              </span>
            </Dropdown>
          </Header>
          <Breadcrumb className={"breadcrumb-padding"}>
            <Breadcrumb.Item>{this.props.breadcrumbPath}</Breadcrumb.Item>
            <Breadcrumb.Item>{this.props.breadcrumbMenu}</Breadcrumb.Item>
          </Breadcrumb>
          <Content
            className="site-layout-background"
            style={this.props.noPadNoMar ? { margin: "0px 16px -10px", padding: 0, minHeight: "100vh" } : { margin: "0px 16px -10px", padding: 24, minHeight: "100vh" }}
          >
            <div>{this.props.children}</div>
          </Content>
          <Footer className={"footer-admin"}>
            Otodis ©{new Date().getFullYear()} | v-{appVersion}
          </Footer>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(AppLayout);
